import React, { FC, useEffect, useState } from 'react';
import { Box, FormControl, IconButton, ListItem } from '@mui/material';
import { NShiftPartnerService, NShiftPartnerServiceAddon } from 'models/nshift-partners';
import NShiftServiceAddonsAutoComplete from './nshift-service-addons-auto-complete.component';

import DeleteIcon from '@mui/icons-material/Delete';
import { TransportPartnerService } from 'models/organization';

type NShiftPartnerServiceItemProps = {
    selectedPartnerService: NShiftPartnerService;
    onAddonSelect: (service: NShiftPartnerService, addons: NShiftPartnerServiceAddon[]) => void;
    onServiceDelete: (index: number) => void;
    index: number;
    savedService?: TransportPartnerService;
};
const NShiftPartnerServiceItem: FC<NShiftPartnerServiceItemProps> = ({
    selectedPartnerService,
    onAddonSelect,
    onServiceDelete,
    index,
    savedService,
}: NShiftPartnerServiceItemProps) => {
    const [savedAddons, setSavedAddons] = useState<NShiftPartnerServiceAddon[]>([]);
    const [addons, setAddons] = useState<NShiftPartnerServiceAddon[]>([]);

    useEffect(() => {
        if (selectedPartnerService) {
            const addonsForDropdown = [...selectedPartnerService.addons];
            setAddons(addonsForDropdown);
            if (savedService?.addons.length) {
                const selectedAddons: NShiftPartnerServiceAddon[] = [];
                for (const addon of savedService?.addons) {
                    const index = addonsForDropdown.findIndex((addonForDropdown) => addonForDropdown.id === addon);
                    if (index > -1) {
                        selectedAddons.push(addonsForDropdown[index]);
                    }
                }
                setSavedAddons(selectedAddons);
            }
        }
    }, [savedService]);

    const handleAddonsSelect = (addons: NShiftPartnerServiceAddon[]) => {
        onAddonSelect(selectedPartnerService, addons);
    };

    return (
        <Box>
            <ListItem>
                <Box mr={1}>
                    {selectedPartnerService.description} ({selectedPartnerService.id})
                </Box>
                <Box mr={1}>
                    <FormControl>
                        <NShiftServiceAddonsAutoComplete
                            nShiftServiceAddons={addons}
                            onAddonsSelect={handleAddonsSelect}
                            savedAddons={savedAddons}
                        />
                    </FormControl>
                </Box>
                <IconButton onClick={() => onServiceDelete(index)} aria-label="delete" size="small">
                    <DeleteIcon />
                </IconButton>
            </ListItem>
        </Box>
    );
};

export default NShiftPartnerServiceItem;
